import i18n from '../../utils/i18n';
import LocationPicker from '@adsk/bim360-matrix-react-location-picker';
import PropTypes from 'prop-types';
import {activityLogChangeType} from '../../constants/proptype-validation/activity-proptypes';
import React from 'react';

const ActivityChangeLocationNode = ({
  isLocationsTreeLoading,
  isLocationsLoadingError,
  locationsTreeNodes,
  change,
  container
}) => {
  if (isLocationsTreeLoading) {
    return i18n.t('locations.loading');
  } else if (isLocationsLoadingError) {
    return i18n.t('locations.error');
  }

  return (
    <LocationPicker
      className="IssuePreviewActivityContent__location-activity-line"
      locationApiPayload={locationsTreeNodes}
      readOnlyValue
      selectedEventKey={change.after}
      popoverContainer={container}
    />
  );
};

ActivityChangeLocationNode.displayName = 'ActivityChangeLocationNode';

ActivityChangeLocationNode.propTypes = {
  isLocationsTreeLoading: PropTypes.bool,
  isLocationsLoadingError: PropTypes.bool,
  locationsTreeNodes: PropTypes.array,
  change: activityLogChangeType,
  container: PropTypes.object
};

export default ActivityChangeLocationNode;
